import { coreInitiativesGetAsyncSlice } from './get';
import { CoreInitiativesName } from './name';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchInitiatives } from '@api';

export const coreInitiativesPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives ]
	},
	name: CoreInitiativesName,
	receive: false,
	request: true,
	requestHandler: patchInitiatives
});
